import { CartCountContext, CartCountContextType } from "@/lib/main";
import { useContext } from "react";

export default function useCartCount(): CartCountContextType {
  const context = useContext(CartCountContext);
  if (!context) {
    throw new Error(
      "useCartCount must be used within a CartCountContext.Provider",
    );
  }
  return context;
}
